export default "__VITE_ASSET__DFBxUW8h__"